import { useQuery } from "@tanstack/react-query";
import { commercialsApi } from "../api/commercials";
import { ChangeEvent, useState } from "react";

export const useCommitments = (projectId: string | undefined) => {

    const [searchDraft, setSearchDraft] = useState<string>('');
    const [searchKey, setSearchKey] = useState<string>('');

    const handleChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchDraft(e.target.value);
    };

    const handleClear = () => {
        setSearchDraft('');
        setSearchKey('');
    };

    const handleSearch = () => {
        setSearchKey(searchDraft);
    };

    const { data, isLoading, isError, error } = useQuery({
        queryKey: ["project-commitments", projectId, searchKey],
        queryFn: () => commercialsApi.fetchCommitments({ projectId, searchKey }),
    });

    return {
        data: data?.data?.rows, isLoading, isError, error,
        searchDraft, handleChangeSearch, handleClear, handleSearch
    };

};